<template>
  <div class="bg-white echart-container">
    <div id="sellTotal" style="width: 960px;height: 204px;"></div>
  </div> 
</template>

<script>
import echarts from '@/utils/echart'
export default {
  data () {
    return {
      charts:null,
    }
  },
  mounted(){
    this.$nextTick(function() {
      this.drawChart('sellTotal')
    })
  },
  methods: {
    drawChart(id) {
      this.charts = echarts.init(document.getElementById(id))
      this.charts.setOption({
        xAxis: {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
            type: 'value'
        },
        series: [{
            data: [0, 0, 0, 0, 0, 0, 0],
            type: 'line',
            smooth: true
        }]
    });
    }
  }
}
</script>

<style lang="scss" scoped>
  .echart-container {
    height: 204px;
    box-shadow: $box-shadow-base;
    border-radius: $border-radius-base;
  }
</style>
